//* 组件库
import type { UiForm, UiTypes } from "various-ui";
import { $loading, $message } from "various-ui";
//* 组件属性
import { useOptions } from "./options";

export const useComposable = () => {
    //* 插件
    const i18n = useI18n();
    //* 配置项
    const options = useOptions();
    //* 临时数据处理
    const specie = options.species?.[0]?.value || "";
    const assemblys = options.assembly?.[specie] || [];

    //* 静态数据
    const vars = {};
    //* 响应式数据
    const refs = {
        send_email: ref<string>(""),
        assembly: ref<UiTypes.candidate[]>(assemblys),
    };

    //* 节点
    const nodes = {
        file: ref<HTMLInputElement>(),
        form: ref<InstanceType<typeof UiForm>>(),
    };

    //* 表单数据
    const data = reactive({
        assembly: assemblys?.[0]?.value || "",
        sequence: "",
        species: specie,
        email: "",
        mode: options.sequence?.[0]?.value || "",
    });

    //* 表单校验规则
    const rules: { [name: string]: UiTypes.verifyRule[] } = {
        sequence: [
            {
                trigger: "change",
                verify: () => {
                    if (data.sequence.trim()) return { verify: true, message: "" };
                    else {
                        return { verify: false, message: i18n.t("PleaseEnterSequence") };
                    }
                },
            },
        ],
    };

    //* 函数列表
    const methods = {
        //* 物种切换
        species: () => {
            refs.assembly.value = options.assembly?.[data.species] || [];
            data.assembly = refs.assembly.value?.[0]?.value || "";
        },

        //* 表单提交函数
        submit: () => {
            nodes.form.value?.validator((result) => {
                if (!result) return;
                else {
                    $loading.open({ message: i18n.t("UnderLoad") });
                    api.frontend("/api/bio/blat", {
                        data: data,
                        method: "POST",
                        finally: () => $loading.close(),
                        success: (response) => {
                            if (response) {
                                nodes.form.value?.reset();
                                window.open(routerResolve({ name: "BLATResult", params: { id: response } }).href as string, "_blank");
                            } else {
                                $message.warning(i18n.t("UnknownError"));
                            }
                        },
                    });
                }
            });
        },

        //* 文件上传
        upload: (ev: Event) => {
            //* 数据初始化
            const dom = ev.target as HTMLInputElement;
            const file = dom?.files?.[0];
            const result = new FormData();
            //* 检测文件是否存在
            if (!file) dom.value = "";
            else {
                //* 开启加载器
                $loading.open({ message: "" });
                //* 文件读取
                result.append("file", file);
                api.frontend("/api/bio/blat/analysis", {
                    data: result,
                    method: "POST",
                    finally: () => {
                        dom.value = "";
                        $loading.close();
                    },
                    success: (response) => {
                        //* 数据更新
                        data.sequence = response.map((value: any) => `>${value.name || ""}\n${value.seq}`).join("\n");
                        //* 表单校验
                        nodes.form.value?.validator(() => {});
                    },
                });
            }
        },
    };

    return { vars, refs, data, nodes, rules, methods, options };
};
